import { css } from '@emotion/css';

export const stopAssignMenuButtonWidth = css`
  width: 29.4rem;
`;
